/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type LoanApplicantIdDocumentType = 'NotSet' | 'MilitaryId' | 'DriversLicense' | 'StateId' | 'Passport' | 'UsaGreenCard' | 'Other';

export const LoanApplicantIdDocumentType = {
    NotSet: 'NotSet' as LoanApplicantIdDocumentType,
    MilitaryId: 'MilitaryId' as LoanApplicantIdDocumentType,
    DriversLicense: 'DriversLicense' as LoanApplicantIdDocumentType,
    StateId: 'StateId' as LoanApplicantIdDocumentType,
    Passport: 'Passport' as LoanApplicantIdDocumentType,
    UsaGreenCard: 'UsaGreenCard' as LoanApplicantIdDocumentType,
    Other: 'Other' as LoanApplicantIdDocumentType
}
